<template>
    <div id="homePageWrapper">
        <!-- 账户信息 -->
        <div
            class="info-header"
            v-if="numInfo && numInfo.organizeProject && numInfo.organizeProject"
        >
            <div class="every-box">
                <p class="titles ys-common-FontColor">账户信息</p>
                <div class="personal ys-common-block ys-common-FontColor">
                    <div>
                        <img src="@/assets/images/icon_touxiang.png" alt="" />
                    </div>
                    <div v-if="userInfo" class="userInfoData">
                        <div>
                            <h2>{{ userInfo.orguser_cn_name }}</h2>
                            <div>
                                <p>{{ userInfo.ent_name }}</p>
                                <p>{{ userInfo.dept_cn_name }}</p>
                            </div>
                        </div>
                        <p>{{ userInfo.crt_date }} {{ userInfo.crt_time }}</p>
                    </div>
                </div>
            </div>
            <div class="every-box" v-if="numInfo.organizeProject">
                <p class="titles ys-common-FontColor">组织结构</p>
                <div class="organization ys-common-block ys-common-FontColor">
                    <div>
                        <p>企业</p>
                        <p>{{ numInfo.organizeProject.ent_num }}</p>
                    </div>
                    <div>
                        <p>部门</p>
                        <p>{{ numInfo.organizeProject.dept_num }}</p>
                    </div>
                    <div>
                        <p>角色</p>
                        <p>{{ numInfo.organizeProject.role_num }}</p>
                    </div>
                    <div>
                        <p>用户</p>
                        <p>{{ numInfo.organizeProject.user_num }}</p>
                    </div>
                </div>
            </div>
            <div class="every-box" v-if="numInfo.organizeProject">
                <p class="titles ys-common-FontColor">项目资源</p>
                <div class="organization ys-common-block ys-common-FontColor">
                    <div>
                        <p>服务器</p>
                        <p>{{ numInfo.organizeProject.server_num }}</p>
                    </div>
                    <div>
                        <p>数据库</p>
                        <p>{{ numInfo.organizeProject.db_num }}</p>
                    </div>
                    <div>
                        <p>主页面</p>
                        <p>{{ numInfo.organizeProject.main_num }}</p>
                    </div>
                    <div>
                        <p>服务</p>
                        <p>{{ numInfo.organizeProject.interface_num }}</p>
                    </div>
                </div>
            </div>
            <div class="every-box">
                <p class="titles ys-common-FontColor">接入</p>
                <div class="access-box ys-common-block ys-common-FontColor">
                    <div class="left">
                        <div>
                            <img src="@/assets/images/icon_qudao.png" alt="" />
                        </div>
                        <div>
                            <p>渠道</p>
                            <p>{{ numInfo.channel }}</p>
                        </div>
                    </div>
                    <div class="right">
                        <div>
                            <img src="@/assets/images/icon_zhongduan.png" alt="" />
                        </div>
                        <div>
                            <p>终端</p>
                            <p>{{ numInfo.terminal }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 内容列表 -->
        <div class="content-box ys-common-FontColor">
            <div class="left-content">
                <div class="btn-box ys-common-FontColor">
                    <div class="title">
                        <span>操作</span>
                    </div>
                    <div>
                        <span
                            :class="item.value == activeTab ? 'active' : ''"
                            v-for="(item, index) in tabInfo"
                            :key="index"
                            @click="changeCon(item.value)"
                        >
                            {{ item.name }}
                        </span>
                    </div>
                </div>
                <div class="counter-number swiper-container ys-common-block">
                    <div class="btnBox">
                        <button class="iconfont ys-iconIcon_Back ys-common-block"></button>
                        <button class="iconfont ys-iconIcon_right ys-common-block"></button>
                    </div>
                    <ul class="swiper-wrapper">
                        <li
                            class="swiper-slide"
                            v-if="numInfo.rsResList"
                            v-for="(item, index) in numInfo.rsResList"
                            :key="index"
                        >
                            <p>{{ item.rs_cn_name }}</p>
                            <p>{{ item.rs_num }}</p>
                        </li>
                    </ul>
                </div>
                <div class="table-box">
                    <el-table
                        :columns="Columns"
                        :tableData="tableData"
                        :loading="tableLoading"
                        :tableHeight="tableHeight"
                    ></el-table>
                </div>
            </div>
            <div class="right-content">
                <p class="title">通知</p>
                <div
                    class="all-list"
                    :style="`height: ${rightHeight}px;overflow: auto;`"
                    v-if="msgInfo.msgList.length"
                >
                    <div
                        class="every-list ys-common-block"
                        v-for="(item, index) in msgInfo.msgList"
                        :key="index"
                    >
                        <div>
                            <p>
                                <span :class="item.rc_flag == 1 ? 'look' : ''">
                                    {{ item.rc_flag == 1 ? '已读' : '未读' }}
                                </span>
                            </p>
                            <p @click="getMsgInfo(item.work_seq, item.rc_flag)">
                                {{ item.msg_text }}
                            </p>
                        </div>
                        <div>{{ item.rc_bk_date + ' ' + item.rc_bk_time }}</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 查看详情 -->
        <add-detail
            v-if="msgInfo.detailStatus"
            :detailValue="msgInfo.detailValue"
            :modelData="msgInfo.modelData"
            @on-detail-click="onDetailClick"
        ></add-detail>
    </div>
</template>
<script>
import elementResizeDetectorMaker from 'element-resize-detector'; // 获取元素的高度
import ElTable from '_g/commonComponent/table/elTable.vue';
import Columns from './tableConfig.js';
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
import AddDetailModel from '@/views/systemNotification/component/AddDetailModel.vue'; // 详情
import { mapGetters, mapActions } from 'vuex';
export default {
    components: {
        'el-table': ElTable,
        'add-detail': AddDetailModel,
    },
    computed: {
        ...mapGetters(['getCommData']),
    },
    data() {
        return {
            tableData: [], // 数据
            Columns: [
                {
                    title: '服务名称',
                    render: function(h, { columns, row, index }) {
                        return h(
                            'div',
                            {
                                style: {
                                    overflow: 'hidden',
                                    'text-overflow': 'ellipsis',
                                    'white-space': 'nowrap',
                                },
                                attrs: {
                                    title: row.org_srv_name,
                                },
                            },
                            row.org_srv_name
                        );
                    },
                },
                {
                    title: '中文名称',
                    key: 'org_srv_bk_desc',
                },
                {
                    title: '请求时长 (ms)',
                    key: 'backup_fld',
                    width: 150,
                },
            ], // 表头
            tableHeight: 0,
            rightHeight: 0,
            userInfo: null, //用户信息
            numInfo: {
                //数字信息
                channel: null, //渠道
                terminal: null, //终端
                organizeProject: null, //组织结构和项目资源
                rsResList: [], //操作
            },
            msgInfo: {
                //系统通知
                msgList: [], //列表
                detailStatus: false, //系统通知显示详情
                modelData: {}, //系统通知详情数据
                detailValue: false,
            },
            tabInfo: [
                {
                    value: 'day',
                    name: '当天',
                },
                {
                    value: 'week',
                    name: '本周',
                },
                {
                    value: 'month',
                    name: '本月',
                },
            ],
            activeTab: 'day',
            defaultStyle: 'translate3d(0px, 0px, 0px)',
            styles: {},
            mySwiper: false, //swiper定位
            YTime: null,
            tableLoading: true, // 表格loading
        };
    },
    methods: {
        ...mapActions([
            'ch_PageChannelAction',
            'pageOnlyUserTermActionList',
            'mg_PageMessageAction',
            'sa_PageLogByLabelAction_getLogTop',
            'sa_QueryHomeView_queryAboutHomeNum',
            'mg_QueryMsgInfoAction',
        ]),
        // 获取元素的高度
        getElementHeight() {
            let ERD = elementResizeDetectorMaker();
            let _this = this;
            ERD.listenTo(document.getElementById('homePageWrapper'), element => {
                _this.tableHeight = element.offsetHeight - 174 - 63 - 141;
                _this.rightHeight = element.offsetHeight - 174 - 63;
            });
        },
        //初始化
        postPort() {
            this.tableLoading = true;
            //渠道
            this.ch_PageChannelAction({
                start_recd: 0,
                limit_recd: 12,
            }).then(res => {
                this.numInfo.channel = res.all_recd || 0;
            });

            //终端
            this.pageOnlyUserTermActionList({
                start_recd: 0,
                limit_recd: 12,
            }).then(res => {
                this.numInfo.terminal = res.all_recd || 0;
            });

            //服务时长
            this.sa_PageLogByLabelAction_getLogTop({
                start_recd: 1,
                limit_recd: 8,
            })
                .then(res => {
                    let len = this.tableData.length;
                    if (res.log_list) {
                        this.tableData.splice(0, len, ...res.log_list);
                        this.tableLoading = false;
                    }
                })
                .catch(err => {
                    this.tableLoading = false;
                });

            this.getNums();

            this.getMsgInfoList();
        },
        //内部消息
        getMsgInfoList() {
            this.mg_PageMessageAction({
                start_recd: 0,
                limit_recd: 12,
                org_user_id: this.userInfo.org_user_id,
            }).then(res => {
                let len = this.msgInfo.msgList.length;
                if (res.msg_list) {
                    this.msgInfo.msgList.splice(0, len, ...res.msg_list);
                }
            });
        },
        //数字信息集合
        getNums() {
            this.sa_QueryHomeView_queryAboutHomeNum({
                type_code: this.activeTab,
            }).then(res => {
                this.numInfo.organizeProject = res;
                let len = this.numInfo.rsResList.length;
                if (res.rsResList) {
                    this.numInfo.rsResList.splice(0, len, ...res.rsResList);
                    this.$nextTick(() => {
                        if (!this.mySwiper) {
                            this.initSwiper();
                        } else {
                            this.mySwiper.slideTo(0, 0, false);
                        }
                    });
                }
            });
        },
        //确定按钮
        onDetailClick() {
            this.msgInfo.detailValue = false;
            this.msgInfo.detailStatus = false;
            this.getMsgInfoList();
        },
        //系统通知详情
        getMsgInfo(workseq, rc_flag) {
            this.mg_QueryMsgInfoAction({
                workseq: workseq,
            }).then(res => {
                this.msgInfo.detailValue = true;
                this.msgInfo.detailStatus = true;
                this.msgInfo.modelData = res.msg_info;
            });
        },
        //当操作条件发生改变时
        changeCon(value) {
            this.activeTab = value;
            this.getNums();
        },
        //swiper引入
        initSwiper() {
            this.mySwiper = new Swiper('.swiper-container', {
                // 如果需要前进后退按钮
                navigation: {
                    nextEl: '.ys-iconIcon_right',
                    prevEl: '.ys-iconIcon_Back',
                },
                slidesPerView: 'auto',
                spaceBetween: 48,
                observer: true,
            });
        },
        timingRequest() {
            if (this.YTime) {
                clearInterval(this.YTime); //关闭
            }
            this.YTime = setInterval(() => {
                this.postPort();
            }, this.$ysConfig.home_timing_request * 1000 * 60);
        },
    },
    mounted() {
        // 获取元素高度
        this.getElementHeight();
        this.userInfo = JSON.parse(this.getCommData);

        //初始化
        this.postPort();
        // 定时请求刷新数据
        this.timingRequest();
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.timingRequest();
        });
    },
    beforeRouteLeave(to, from, next) {
        if (this.YTime && to.name != this.$route.name) {
            //如果定时器还在运行 或者直接关闭，不用判断
            clearInterval(this.YTime); //关闭
            next();
        }
    },
};
</script>
<style lang="less" scoped>
#homePageWrapper {
    width: 100%;
    height: 100%;
    padding: 0 50px;
    box-sizing: border-box;
    overflow: hidden;

    .info-header {
        width: 100%;
        height: 174px;
        padding-top: 38px;
        box-sizing: border-box;
        display: flex;
        flex-wrap: nowrap;

        .userInfoData {
            & > div:nth-of-type(1) {
                display: flex;
                width: 100% !important;
                height: 48px !important;

                div {
                    height: 48px !important;
                    flex-grow: 1;
                }

                h2 {
                    font-size: 25px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    // color: #d9e3f3;
                    line-height: 48px;
                    margin-right: 12px;
                    flex-shrink: 1;
                    width: 136px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }

                p {
                    font-size: 14px !important;
                    line-height: 24px !important;
                    margin-bottom: 0 !important;
                    width: 100%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
        }

        .every-box {
            width: 25%;
            margin-right: 15px;

            .titles {
                font-size: 16px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                // color: rgba(217, 227, 243, 1);
                margin-bottom: 15px;
            }
        }

        .every-box:nth-of-type(1) {
            .personal {
                width: 100%;
                height: 100px;
                // background: rgba(47, 61, 87, 1);
                border-radius: 6px;
                display: flex;
                flex-wrap: nowrap;
                padding: 16px 25px 16px 25px;
                box-sizing: border-box;

                div:nth-of-type(1) {
                    width: 66px;
                    height: 66px;
                    border-radius: 66px;
                    margin-right: 30px;

                    img {
                        width: 66px;
                        height: 66px;
                        vertical-align: middle;
                    }
                }

                div:nth-of-type(2) {
                    p:nth-of-type(1) {
                        font-size: 20px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        // color: rgba(217, 227, 243, 1);
                        margin-bottom: 16px;
                    }

                    p:nth-of-type(2) {
                        font-size: 13px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        // color: rgba(217, 227, 243, 1);
                    }
                }
            }
        }

        .every-box:nth-of-type(2),
        .every-box:nth-of-type(3) {
            .organization {
                width: 100%;
                height: 100px;
                // background: rgba(47, 61, 87, 1);
                border-radius: 6px;
                display: flex;
                flex-wrap: nowrap;
                padding: 16px 0px 16px 0px;
                box-sizing: border-box;

                div {
                    width: 25%;
                    text-align: center;

                    p:nth-of-type(1) {
                        font-size: 14px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        // color: rgba(217, 227, 243, 1);
                    }

                    p:nth-of-type(2) {
                        font-size: 36px;
                        font-family: DINbekMedium;
                        // color: rgba(217, 227, 243, 1);
                    }
                }
            }
        }

        .every-box:nth-of-type(4) {
            margin-right: 0px;

            .access-box {
                width: 100%;
                height: 100px;
                // background: rgba(47, 61, 87, 1);
                border-radius: 6px;
                display: flex;
                flex-wrap: nowrap;
                padding: 16px 0px 16px 0px;
                box-sizing: border-box;

                .left,
                .right {
                    width: 50%;
                    display: flex;
                    flex-wrap: nowrap;
                    text-align: center;
                    padding-left: 28px;
                    box-sizing: border-box;

                    div:nth-of-type(1) {
                        width: 50px;
                        height: 42px;
                        padding-top: 14px;
                        box-sizing: border-box;
                        margin-right: 20px;

                        img {
                            width: 50px;
                            height: 42px;
                            vertical-align: middle;
                        }
                    }

                    div:nth-of-type(2) {
                        p:nth-of-type(1) {
                            font-size: 14px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            // color: rgba(217, 227, 243, 1);
                            margin-right: 20px;
                        }

                        p:nth-of-type(2) {
                            font-size: 30px;
                            font-family: DINbekMedium;
                            // color: rgba(217, 227, 243, 1);
                        }
                    }
                }

                .left {
                    border-right: 1px solid rgba(217, 227, 243, 1);
                }
            }
        }
    }

    .content-box {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        flex-wrap: nowrap;

        .right-content {
            width: 50%;
            margin-right: 0;

            .title {
                width: 100%;
                height: 63px;
                padding: 24px 0 17px 0px;
                box-sizing: border-box;
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                // color: rgba(217, 227, 243, 1);
            }

            .all-list {
                width: 100%;

                .every-list {
                    width: 100%;
                    height: 58px;
                    // background: rgba(56, 71, 99, 1);
                    border-radius: 6px;
                    padding: 15px 17px;
                    box-sizing: border-box;
                    margin-bottom: 12px;
                    display: flex;
                    flex-wrap: nowrap;
                    justify-content: space-between;
                    align-items: center;

                    div:nth-of-type(1) {
                        width: 602px;
                        display: flex;
                        flex-wrap: nowrap;

                        p:nth-of-type(1) {
                            width: 40px;
                            flex-shrink: 1;

                            span {
                                padding: 3px;
                                line-height: 18px;
                                text-align: center;
                                background: rgba(0, 97, 255, 1);
                                border-radius: 4px;
                                font-size: 14px;
                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 400;
                                // color: rgba(217, 227, 243, 1);

                                &.look {
                                    background: rgba(0, 97, 255, 0.5);
                                    color: rgba(217, 227, 243, 0.5);
                                }
                            }
                        }

                        p:nth-of-type(2) {
                            width: 550px;
                            font-size: 14px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            // color: rgba(217, 227, 243, 1);
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            word-break: break-all;
                            margin-left: 20px;
                            cursor: pointer;
                        }
                    }

                    div:nth-of-type(2) {
                        font-size: 14px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        // color: rgba(217, 227, 243, 1);
                    }
                }
            }
        }

        .left-content {
            width: 50%;
            margin-right: 15px;

            .btn-box {
                width: 100%;
                height: 63px;
                padding: 24px 0 17px 0px;
                box-sizing: border-box;
                display: flex;
                flex-wrap: nowrap;
                justify-content: space-between;

                .title {
                    font-size: 16px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    // color: rgba(217, 227, 243, 1);
                }

                div:nth-of-type(2) {
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    // color: rgba(161, 174, 197, 1);

                    span {
                        margin-left: 44px;
                        cursor: pointer;
                    }
                }

                .active {
                    // color: rgba(220, 232, 255, 1);
                }
            }

            .counter-number {
                width: 100%;
                height: 127px;
                // background: rgba(47, 61, 87, 1);
                border-radius: 6px;
                padding: 28px 37px;
                box-sizing: border-box;
                margin-bottom: 14px;
                overflow: hidden;
                position: relative;

                .btnBox {
                    position: absolute;
                    left: 12px;
                    top: 8px;

                    button {
                        // background: rgba(57, 73, 106, 1);
                        border-radius: 2px;
                        // color: rgba(161, 174, 197, 1);
                        font-size: 12px;
                        border: none;
                        cursor: pointer;

                        .noClick {
                            color: rgba(161, 174, 197, 0.5);
                        }
                    }
                }

                ul {
                    display: flex;
                    flex-wrap: nowrap;
                    justify-content: start;

                    li {
                        p:nth-of-type(1) {
                            font-size: 13px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            // color: rgba(217, 227, 243, 1);
                            white-space: nowrap;
                        }

                        p:nth-of-type(2) {
                            font-size: 40px;
                            font-family: DINbekMedium;
                            // color: rgba(217, 227, 243, 1);
                            text-align: center;
                        }
                    }
                }
            }
        }
    }

    .swiper-slide {
        width: auto;
    }
}
</style>
